async function post(path, body, token) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.message || `Request to ${path} failed`);
  if (data && data.success === false) throw new Error(data.message || `Request to ${path} failed`);
  return data;
}

export function getCheckpointGame({ token, stageId, userId, themeName }) {
  return post("/getCheckpointGame", { stageId, userId, themeName }, token);
}

export function requestCheckpointHint({ token, stageId, roundIndex, themeName }) {
  return post("/useCheckpointHint", { stageId, roundIndex, themeName }, token);
}

export function submitCheckpointAnswer({ token, stageId, roundIndex, answer, selectedOption, themeName }) {
  return post("/submitCheckpointAnswer", { stageId, roundIndex, answer, selectedOption, themeName }, token);
}

export function getLiveHuntStatus({ token, themeName }) {
  return post("/getLiveHuntStatus", { themeName }, token);
}

export function reviewCheckpointPhoto({ token, stageId, approve, bonusPoints, themeName }) {
  return post("/reviewCheckpointPhoto", { stageId, approve, bonusPoints, themeName }, token);
}

export function adminCompleteRound({ token, stageId, themeName }) {
  return post("/adminCompleteRound", { stageId, themeName }, token);
}

export function exportHuntResults({ token, themeName }) {
  return post("/exportHuntResults", { themeName }, token);
}

export function getHuntResult({ token, stageId, userId, themeName }) {
  return post("/getHuntResult", { stageId, userId, themeName }, token);
}

export function getLeaderboard({ token, themeName, limit }) {
  return post("/getLeaderboard", { themeName, limit }, token);
}

// Media (photo/video/audio/gif) submissions upload straight to S3 via a presigned URL instead of
// through our own API — this backend runs behind API Gateway, which hard-caps request bodies at
// ~10MB, and a real phone video/audio recording routinely exceeds that. Going direct to S3 avoids
// that limit entirely; see getMediaUploadUrl.js / submitCheckpointPhoto.js on the backend.
export async function submitCheckpointPhoto({ token, stageId, roundIndex, themeName, photoFile }) {
  const presign = await post(
    "/getMediaUploadUrl",
    { stageId, roundIndex, themeName, fileName: photoFile.name || "", contentType: photoFile.type || "" },
    token
  );

  const putResp = await fetch(presign.uploadUrl, {
    method: "PUT",
    headers: { "Content-Type": presign.contentType || photoFile.type || "application/octet-stream" },
    body: photoFile,
  });
  if (!putResp.ok) {
    throw new Error("Failed to upload the file — check your connection and try again.");
  }

  return post("/submitCheckpointPhoto", { stageId, roundIndex, themeName, filename: presign.filename }, token);
}
